import React, { Component } from "react";
import logo from "../../assets/Ministerie van Justitie.png";
import PhoneInput from "react-phone-number-input";
import Api from "../../Api";

class ProtehamiForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      loading: false,
    };

    this.CheckBoxField = this.CheckBoxField.bind(this);
    this.TextField = this.TextField.bind(this);
    this.TextAreaField = this.TextAreaField.bind(this);
    this.EmailField = this.EmailField.bind(this);
    this.SelectField = this.SelectField.bind(this);
    this.DateField = this.DateField.bind(this);
    this.PhoneField = this.PhoneField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit(data) {
    this.setState({ loading: true });

    const newAdressData = {
      defDossier: 1941,
      33691: data.straatnaam_persoon,
      33694: data.politiedistrict,
      33696: data.wijk_persoon,
      33697: data.geozone_persoon,
    };

    const idnewAdressData = await Api.dossiers.Create(newAdressData);

    const adressData = {
      defDossier: 1826,
      31298: data.huisnummer_persoon,
      31319: data.toevoeging_persoon,
      31331: data.woonplaats_persoon,
      33698: [idnewAdressData.id],
    };

    const idadressData = await Api.dossiers.Create(adressData);

    const gevensBetroData = {
      31201: data.voornamen_persoon,
      31217: data.gevens_persoon,
      31227: data.email_persoon,
      31205: data.phone_persoon,
      31256: data.geslacht,
      31453: data.geboortedatum_melding,
      31260: data.identiteitsnummer_persoon,
      32978: data.geboorteplaats_persoon,
      31466: [idadressData.id],
      71885: data.gezag,
      defDossier: "1818",
    };

    const idgevensBetroData = await Api.dossiers.Create(gevensBetroData);

    const directBetroData = {
      defDossier: "3520",
      70494: data.achternaam_betro,
      70499: data.voornaam_betro,
      70504: data.geboortedatum_betro,
      70506: data.geboorteplaats_betro,
      70509: data.nationaliteit_betro,
      70510: data.id_Nummer_betro,
      70512: data.adres_betro,
      70515: data.email_betro,
      70517: data.phone_betro,
      70518: data.relatie_betro,
    };
    const idDirectBetro = await Api.dossiers.Create(directBetroData);

    let betrokkenData;
    if (data.naam_instanties) {
      betrokkenData = {
        defDossier: "3519",
        70404: data.naam_instanties,
        70408: data.instantie_instanties,
        70411: data.phone_instanties,
        70413: data.email_instanties,
        70416: data.relatie_instanties,
      };
    }

    let idbetrokkenData;
    if (betrokkenData) {
      idbetrokkenData = await Api.dossiers.Create(betrokkenData);
    }

    const aanmeldingenData = {
      defDossier: "3518",
      70226: data.datum_melding,
      70424: data.punten,
      72189: data.contactpersoon,
      70428: data.naam_melder,
      70429: data.instantie,
      70430: data.phone_melder,
      70233: data.relatie_melder,
      70431: data.email_melder,
      70432: data.vooraf,
      70434: data.meldt,
      70436: data.inhoud,
      70437: data.melding,
      70439: data.gebeurt,
      70440: data.verwacht,
      70441: data.toelichting,
      70443: data.veiligheidsschaal,
      70444: data.woorden,
      70213: [35177],
      70520: [idDirectBetro.id],
      70445: [idgevensBetroData.id],
    };

    if (idbetrokkenData) {
      aanmeldingenData[70447] = [idbetrokkenData.id];
    }

    const idaanmeldingenData = await Api.dossiers.Create(aanmeldingenData);
 
    this.setState({ loading: false });
    this.setState({ showModal: true });
  }

  formatDateToISO(date) {
    const isoString = new Date(date).toISOString();
    return isoString;
  }

  TextField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="text"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  DateField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <input
            {...register(name, rules)}
            type="date"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  CheckBoxField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;
    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          {options.map((opt, idx) => (
            <div className="flex gap-2" key={idx}>
              <input
                type="checkbox"
                {...register(name, rules)}
                value={opt.value}
              />
              <label className="float-left text-left">{opt.label}</label>
            </div>
          ))}

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  PhoneField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <PhoneInput
            placeholder="Enter phone number"
            {...register(name, rules)}
            value={this.state[name]}
            onChange={(value) => this.setState({ [name]: value })}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
          />

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  EmailField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required.value && <span className="text-red-500">*</span>}{" "}
            {label}
          </label>
          <input
            {...register(name, rules)}
            type="email"
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  SelectField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <select
            {...register(name, rules)}
            name={name}
            onChange={(e) => {
              this.setState({ [name]: [e.target.value] });
            }}
            className="h-10 border mt-1 rounded px-2 w-full bg-gray-50"
          >
            <option value="">Selecteer een optie</option>
            {options.map((opt) => (
              <option value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  TextAreaField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start w-full">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <textarea
            rows={3}
            {...register(name, rules)}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-md h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Successfully!
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="p-5 d-flex flex-column gap-5">
          <div className="d-flex justify-content-center w-full">
            <img src={logo} alt="logo" />
          </div>
          <div>
            <h1 className="text-3xl font-bold spt-2">
              Meldformulier ProtehaMi
            </h1>

            <p className="text-base mt-6">
              Met dit formulier kunt u een melding doen bij ProtehaMi. Alvorens
              u over gaat tot het doen van een melding eerst telefonisch overleg
              met ProtehaMi (+5999 6632803).
            </p>
          </div>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="flex justify-between items-start">
              {this.CheckBoxField(
                `Wilt u op deze pagina aankruisen welke punten op u van toepassing zijn:`,
                "punten",
                [
                  {
                    value: 35204,
                    label: "Een melding van relationeel geweld.",
                  },
                  {
                    value: 35205,
                    label: "Een melding van kindermishandeling.",
                  },
                  {
                    value: 35206,
                    label:
                      "Anoniem blijven ten opzichte van de directe betrokkenen/slachtoffer.",
                  },
                  {
                    value: 35207,
                    label:
                      "De vijf stappen van de beschermingscode zijn doorlopen.",
                  },
                  {
                    value: 35208,
                    label:
                      "De vijf stappen van de beschermingscode zijn NIET doorlopen. ",
                  },
                ],
                {
                  required: {
                    value: true,
                    message: "field is required",
                  },
                }
              )}
            </form>
          </div>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <p className="text-justify">
              Indien u meerdere personen wenst te melden, dan verzoeken wij u
              per persoon of per kind een formulier in te vullen. Als u niet
              beschikt over alle informatie, dan verzoeken wij u datgene in te
              vullen wat u wel weet.
            </p>
            <form className="grid grid-cols-2 gap-3 mt-3">
              {this.DateField("Datum melding", "datum_melding", {
                required: "This Field required",
              })}
              {this.SelectField(
                "Naam contactpersoon ProtehaMi:",
                "contactpersoon",
                [
                  {
                    value: 525889,
                    label: "Viandrelica Narcisio",
                  },
                  {
                    value: 3009804,
                    label: "Areina Martina",
                  },
                  {
                    value: 525911,
                    label: "Milouska Everitz",
                  },
                  {
                    value: 525912,
                    label: "Sheneka Obsipo",
                  },
                  {
                    value: 2518293,
                    label: "Sohely Dandare",
                  },
                  {
                    value: 525896,
                    label: "Stephanie Ogenia",
                  },
                  {
                    value: 3042456,
                    label: "Raizella Manuel",
                  },
                  {
                    value: 3067849,
                    label: "Met niemand gesproken",
                  },
                ],
                {
                  required: false,
                }
              )}
            </form>
          </div>

          <h1 className="text-3xl font-bold">Melder</h1>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-2 gap-3 mt-3">
              {this.TextField("Naam melder", "naam_melder", {
                required: true,
              })}
              {this.TextField("Instantie", "instantie", {
                required: true,
              })}
              {this.TextField("Relatie tot slachtoffer", "relatie_melder", {
                required: true,
              })}
              {this.PhoneField("Telefoonnummer(s)", "phone_melder", {
                required: "This Field Is Required",
              })}
              {this.EmailField("E-mailadres", "email_melder", {
                required: { value: false, message: "Email is required" },
              })}
              {this.SelectField(
                "Is er vooraf overleg geweest met ProtehaMi:",
                "vooraf",
                [
                  {
                    value: 15934,
                    label: "Ja",
                  },
                  {
                    value: 15930,
                    label: "Nee",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.SelectField(
                "Zijn de betrokkenen op de hoogte van het feit dat u meldt?:",
                "meldt",
                [
                  {
                    value: 15934,
                    label: "Ja",
                  },
                  {
                    value: 15930,
                    label: "Nee",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.SelectField(
                "Is de inhoud van de melding besproken?:",
                "inhoud",
                [
                  {
                    value: 15934,
                    label: "Ja",
                  },
                  {
                    value: 15930,
                    label: "Nee",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.TextAreaField(
                "Zo, ja met wie is de melding besproken?",
                "melding",
                {
                  required: "This Field is Required",
                }
              )}
            </form>
          </div>

          <h1 className="text-3xl font-bold spt-2">
            Gegevens van betrokken (minderjarige of slachtoffer).
          </h1>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-3  gap-3 mt-3">
              {this.TextField("Voornamen", "voornamen_persoon", {
                required: true,
              })}
              {this.TextField("Achternaam", "gevens_persoon", {
                required: true,
              })}
              {this.EmailField("E-mailadres", "email_persoon", {
                required: { value: false, message: "Email is required" },
              })}
              {this.PhoneField("Telefoon ", "phone_persoon", {
                required: "This Field Is Required",
              })}
              {this.DateField("Geboortedatum", "geboortedatum_melding", {
                required: "This Field required",
              })}
              {this.SelectField(
                "Geslacht:",
                "geslacht",
                [
                  {
                    value: 15943,
                    label: "Onbekend",
                  },
                  {
                    value: 15941,
                    label: "Vrouw",
                  },
                  {
                    value: 15938,
                    label: "Man",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.TextField(
                "Identiteitsnummer",
                "identiteitsnummer_persoon",
                {
                  required: true,
                }
              )}
              {this.TextField("Geboorteplaats", "geboorteplaats_persoon", {
                required: true,
              })}
              {this.SelectField(
                "Gezag berust bij ",
                "gezag",
                [
                  {
                    value: 38863,
                    label: "Voogd",
                  },
                  {
                    value: 35637,
                    label: "Familielid",
                  },
                  {
                    value: 35636,
                    label: "Pleegouders",
                  },
                  {
                    value: 35635,
                    label: "Moeder",
                  },
                  {
                    value: 35634,
                    label: "Vader",
                  },
                  {
                    value: 35633,
                    label: "Ouders",
                  },
                ],
                {
                  required: false,
                }
              )}
            </form>

            <div className="flex items-start my-4">
              <label
                for="tussenvoegsels"
                className="form-label fw-bold float-start"
              >
                Adres:
              </label>
            </div>

            <form className="grid grid-cols-3  gap-3 mt-3">
              {this.TextField("Straatnaam", "straatnaam_persoon", {
                required: true,
              })}
              {this.SelectField(
                "In politiedistrict:",
                "politiedistrict",

                [
                  {
                    value: 631735,
                    label: "Otrobanda",
                  },
                  {
                    value: 631734,
                    label: "Barber",
                  },
                  {
                    value: 631733,
                    label: "Rio Canario",
                  },
                  {
                    value: 631732,
                    label: "Montagne",
                  },
                  {
                    value: 631731,
                    label: "Punda",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.TextField("Wijk", "wijk_persoon", {
                required: false,
              })}
              {this.TextField("Geozone", "geozone_persoon", {
                required: false,
              })}
            </form>

            <form className="grid grid-cols-3  gap-3 mt-3">
              {this.TextField("Huisnummer", "huisnummer_persoon", {
                required: true,
              })}
              {this.TextField("Toevoeging ", "toevoeging_persoon", {
                required: false,
              })}
              {this.TextField("Woonplaats ", "woonplaats_persoon", {
                required: true,
              })}
            </form>
          </div>

          <h1 className="text-3xl font-bold spt-2">
            Gegevens direct betrokkenen
          </h1>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-4 gap-3 mt-3">
              {this.TextField("Achternaam", "achternaam_betro", {
                required: true,
              })}
              {this.TextField("Voornaam", "voornaam_betro", {
                required: true,
              })}
              {this.DateField("Geboortedatum", "geboortedatum_betro", {
                required: "This Field required",
              })}
              {this.TextField("Geboorteplaats", "geboorteplaats_betro", {
                required: true,
              })}
              {this.TextField("Nationaliteit", "nationaliteit_betro", {
                required: true,
              })}
              {this.TextField("ID Nummer", "id_Nummer_betro", {
                required: true,
              })}
              {this.TextField("Adres", "adres_betro", {
                required: true,
              })}
              {this.EmailField("E-mailadres", "email_betro", {
                required: { value: false, message: "Email is required" },
              })}
              {this.PhoneField("Telefoonnummer(s)", "phone_betro", {
                required: "This Field Is Required",
              })}
              {this.TextField("Relatie tot slachtoffer ", "relatie_betro", {
                required: true,
              })}
            </form>
          </div>

          <div
            className=" bg-white rounded-lg shadow-md border border-gray-200 p-6"
            onSubmit={this.submitForm}
          >
            <form className="grid grid-cols-1 gap-3 mt-3">
              {this.TextAreaField(
                "Wat gebeurt/ gebeurde er feitelijk (aard/ernst en duur).",
                "gebeurt",
                {
                  required: "This Field is Required",
                }
              )}
            </form>

            <form className="grid grid-cols-2 gap-3 mt-3">
              {this.CheckBoxField(
                `Wat verwacht u van ProtehaMi?:`,
                "verwacht",
                [
                  {
                    value: 35209,
                    label:
                      "Verzoek tot onderzoek (o.a. jeugdbeschermende maatregel).",
                  },
                  {
                    value: 35210,
                    label:
                      "Vrijwillige hulpverlening (o.a. integrale aanpak of intensiveren).",
                  },
                  {
                    value: 35211,
                    label: "Doorverwijzen (maatwerk).",
                  },
                  {
                    value: 35212,
                    label:
                      "Beschermingstafel organiseren binnen Zorg- en Veiligheidshuis Curaçao",
                  },
                ],
                {
                  required: {
                    value: true,
                    message: "field is required",
                  },
                }
              )}

              {this.TextAreaField("Toelichting:", "toelichting", {
                required: "This Field is Required",
              })}

              {this.SelectField(
                "Veiligheidsschaal",
                "veiligheidsschaal",
                [
                  {
                    value: 35213,
                    label: "0",
                  },
                  {
                    value: 35214,
                    label: "1",
                  },
                  {
                    value: 35215,
                    label: "2",
                  },
                  {
                    value: 35216,
                    label: "3",
                  },
                  {
                    value: 35217,
                    label: "4",
                  },
                  {
                    value: 35218,
                    label: "5",
                  },
                  {
                    value: 35219,
                    label: "6",
                  },
                  {
                    value: 35220,
                    label: "7",
                  },
                  {
                    value: 35221,
                    label: "8",
                  },
                  {
                    value: 35222,
                    label: "9",
                  },
                  {
                    value: 35223,
                    label: "10",
                  },
                ],
                {
                  required: true,
                }
              )}

              {this.TextAreaField(
                "Licht in enkele woorden toe wat dit cijfer voor jou betekent:",
                "woorden",
                {
                  required: "This Field is Required",
                }
              )}
            </form>
          </div>

          <h1 className="text-3xl font-bold spt-2">Betrokken instanties</h1>

          <div className=" bg-white rounded-lg shadow-md border border-gray-200 p-6">
            <div
              className=" bg-white rounded-lg shadow-md border border-gray-200 p-6 mb-2"
              onSubmit={this.submitForm}
            >
              <form className="grid grid-cols-3 gap-3 mt-3">
                {this.TextField("Naam", "naam_instanties", {
                  required: false,
                })}
                {this.TextField("Instantie", "instantie_instanties", {
                  required: false,
                })}
                {this.PhoneField("Telefoonnummer(s)", "phone_instanties", {
                  required: false,
                })}
                {this.EmailField("E-mailadres", "email_instanties", {
                  required: { value: false, message: "Email is required" },
                })}
                {this.TextField("Relatie", "relatie_instanties", {
                  required: false,
                })}
              </form>
            </div>
          </div>

          <form
            className="grid grid-cols-2 gap-3 mt-3"
            onSubmit={handleSubmit(this.onSubmit)}
          >
            <div className="col-span-4">
              <button
                type="submit"
                className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
              >
                Verstuur
              </button>
            </div>
          </form>
        </div>
      </>
    );
  }
}

export default ProtehamiForm;
